module.exports = __webpack_public_path__ + "static/transcript-753ddff8c168204dab75f608e02362a8.png";